<div class="mb-4 flex flex-col text-center gap-2">
    <div class="flex gap-3 justify-center items-center">
        <span class="screen-back-arrow" routerLink="/login"><i class="icon icon-arrow-left"></i></span>
        <h2 class="mb-0">{{LABELS.RESET_PASSWORD}}?</h2>
    </div>
    <p class="mb-0 text-grey94 text-fs14">{{LABELS.RESET_PASSWORD_LABEL}}</p>
</div>

<div class="form-scroll">
    <form (submit)="onSubmit()" [formGroup]="updateForm" class="form-area">
        <div class="relative">
            <div class="input-wrapper !flex-row !gap-4">
                @for (digit of otpControls; track digit) {
                <input class="text-center !p-0 !max-w-14 md:!max-w-16 !h-10 md:!h-12 xxl:!h-14" type="text"
                    maxlength="1" [attr.data-index]="$index" name="otp{{ $index }}" required
                    (input)="onInput($event, $index)" (keydown)="onKeyDown($event, $index)" (paste)="onPaste($event)" />
                }
            </div>
            @if (otpForm.invalid && otpForm.touched) {
            <p class="error">
                {{ LABELS.SIX_DIGIT_OTP_REQUITED }}
            </p>
            }
        </div>
        <div class="show-timer">
            @if (hideResendBtn) {
            <p class="text-fs14 text-grey66 mb-0">{{ LABELS.RESEND_OTP_IN }} <span
                    class="inline-block text-purple font-fw600 min-w-24">{{ transform(seconds) }}</span></p>
            } @else {
            <div class="text-fs14 text-grey66 mb-0" [ngClass]="isSendOtp?'disabled-send-otp':''">
                <button (click)="resendOTP()" [disabled]="isSendOtp" type="button">{{ LABELS.RESEND_OTP }}</button>
            </div>
            }
        </div>
        <div class="input-wrapper mb-3">
            <label for="password">{{LABELS.NEW_PASSWORD}}</label>
            <div class="with-icon-input password-input">
                <i class="icon icon-lock"></i>
                <input #passwordField [formControlName]="'password'" id="password" name="password" type="password"
                    placeholder="Enter your new password" required (keydown.space)="$event.preventDefault()" />
                <i [ngClass]="passwordField.type == 'password' ? 'icon-eye' : 'icon-eye-slash'"
                    class="icon icon-eye-pos cursor-pointer !bg-grey66"
                    (click)="passwordField.type == 'password' ? (passwordField.type = 'text') : (passwordField.type = 'password')"
                    (keydown.enter)="passwordField.type == 'password' ? (passwordField.type = 'text') : (passwordField.type = 'password')"></i>
            </div>
            @if (passwordStrength) {
            <div class="password-strength mt-2 mb-1">
                <p class="text-fs12 mb-1 !font-fw600" [ngStyle]="{
                                    'color': passwordStrength === 'Weak' ? '#ff3b30' : (passwordStrength === 'Medium' ? '#ff9500' : (passwordStrength === 'Strong' ? '#34c759' : '#008000'))
                                }">
                    {{ passwordStrength === 'Weak' ? LABELS.WEAK : (passwordStrength === 'Medium' ?
                    LABELS.MEDIUM : (passwordStrength === 'Strong' ? LABELS.STRONG : LABELS.VERY_GOOD)) }}
                </p>
                <div class="strength-bar flex gap-1 h-1.5 w-full bg-greyf1 rounded-full overflow-hidden">
                    <div class="h-full rounded-full transition-all duration-300" [ngStyle]="{
                                        'width': passwordStrength === 'Weak' ? '25%' : (passwordStrength === 'Medium' ? '50%' : (passwordStrength === 'Strong' ? '75%' : '100%')),
                                        'background-color': passwordStrength === 'Weak' ? '#ff3b30' : (passwordStrength === 'Medium' ? '#ff9500' : (passwordStrength === 'Strong' ? '#34c759' : '#008000'))
                                    }"></div>
                </div>
            </div>
            }
            @if (updateForm.get('password')?.touched && updateForm.get('password')?.errors?.['required']) {
            <p class="error">
                {{ LABELS.PASSWORD_REQUIRED }}
            </p>
            }
            @if (updateForm.get('password')?.touched && updateForm.get('password')?.errors?.['pattern'])
            {
            <p class="error">
                {{LABELS.PASSWORD_COMPLEXITY}}
            </p>
            }
        </div>
        <div class="input-wrapper">
            <label for="confirmPassword">{{LABELS.CONFIRM_PASSWORD}}</label>
            <div class="with-icon-input password-input">
                <i class="icon icon-lock"></i>
                <input #confirmPasswordField [formControlName]="'confirmPassword'" id="confirmPassword"
                    name="confirmPassword" type="password" placeholder="Enter your confirm password" required
                    (keydown.space)="$event.preventDefault()" />
                <i [ngClass]="confirmPasswordField.type == 'password' ? 'icon-eye' : 'icon-eye-slash'"
                    class="icon icon-eye-pos cursor-pointer !bg-grey66"
                    (click)="confirmPasswordField.type == 'password' ? (confirmPasswordField.type = 'text') : (confirmPasswordField.type = 'password')"
                    (keydown.enter)="confirmPasswordField.type == 'password' ? (confirmPasswordField.type = 'text') : (confirmPasswordField.type = 'password')"></i>
            </div>
            @if (updateForm.get('confirmPassword')?.touched && updateForm.get('confirmPassword')?.errors?.['required'])
            {
            <p class="error">
                {{ LABELS.CONFIRM_PASSWORD_REQUIRED }}
            </p>
            }
            @if (updateForm.get('confirmPassword')?.touched &&
            updateForm.get('confirmPassword')?.errors?.['confirmedValidator']){
            <p class="error">
                {{LABELS.PASSWORD_NOT_MATCH}}
            </p>
            }
        </div>
        <div class="mt-2">
            <button class="btn btn-primary" [disabled]="isSubmitting">
                @if (!isSubmitting) {
                <ng-container>
                    {{LABELS.RESET_PASSWORD}}
                </ng-container>
                }
                @if (isSubmitting) {
                <svg class="animate-spin h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="white" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                </svg>
                <span> {{LABELS.RESET_PASSWORD}}</span>
                }
            </button>
        </div>
    </form>
</div>